const Container = ({ children, ...rest }) => (
    <div
        className="container mx-auto my-4 px-4"
        {...rest}>
        {children}
    </div>
);

export default Container;